import { AfterViewInit, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import * as _ from 'lodash';
import { IImageItem } from './models/image-item.interface';
import { UtilityService } from '../../services/utility/utility.service';
import 'hammerjs';

@Component({
  selector: 'upsc-image-rotator',
  templateUrl: './image-rotator.component.html',
  styleUrls: ['./image-rotator.component.scss'],
})
export class ImageRotatorComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  @Input() imageItems: IImageItem[];
  @Input() speed = 3000;
  @Input() isAutoForward = true;

  public images: IImageItem[];
  public isMultipleImages = false;
  public maxSmallSize = '25.9em'; // size increased to support iphone 7/8 plus - (old)public maxSmallSize = '23.5375em';
  public maxMediumSize = '63.9375em';

  private currentImageIndex = 0;
  private nextImageIndex = 0;
  private imageDelay: any;

  constructor(private utilityService: UtilityService) {
  }

  public ngOnInit() {
  }

  public ngOnChanges(changes: SimpleChanges) {
    this.onImageItemsChanged(changes['imageItems']);
  }

  public ngOnDestroy() {
    if (this.imageDelay) {
      clearTimeout(this.imageDelay);
    }
  }

  public ngAfterViewInit() {
    this.setCurrentImage(0);
  }

  private onImageItemsChanged(change: SimpleChange) {
    if (!change || !change.currentValue) {
      this.images = [];
      this.isMultipleImages = false;
      return;
    }

    this.images = _.cloneDeep(change.currentValue);
    this.isMultipleImages = this.images.length > 1;
    this.refindImageUrls(this.images);
  }

  private refindImageUrls(images: IImageItem[]) {
    images.map(
        (imageItem) => {
          imageItem.smallImageUrl = imageItem.smallImageUrl
              || imageItem.mediumImageUrl
              || imageItem.largeImageUrl
              || imageItem.placeholderImageUrl;

          imageItem.mediumImageUrl = imageItem.mediumImageUrl
              || imageItem.smallImageUrl
              || imageItem.largeImageUrl
              || imageItem.placeholderImageUrl;

          imageItem.largeImageUrl = imageItem.largeImageUrl
              || imageItem.smallImageUrl
              || imageItem.mediumImageUrl
              || imageItem.placeholderImageUrl;
        },
    );
  }

  public setCurrentImage(imageIndex: number) {
    if (!this.images) {
      return;
    }

    let currentIndex = imageIndex < 0 ? 0 : imageIndex;
    if (currentIndex >= this.images.length) {
      currentIndex = 0;
    }

    this.images.map(
        (image, index) => {
          image.isCurrent = index === currentIndex;
          return image;
        });

    this.currentImageIndex = currentIndex;

    const isSmallScreen = window.matchMedia('(max-width: 32.5375em)').matches;
    if (this.images.length <= 1 || !this.isAutoForward || isSmallScreen) {
      return;
    }

    this.nextImageIndex = this.currentImageIndex + 1;
    clearTimeout(this.imageDelay);
    this.imageDelay = this.utilityService.delay(() => this.setCurrentImage(this.nextImageIndex), this.speed);
  }

  public showPreviousImage(event) {
    event.preventDefault();

    this.setCurrentImage(this.currentImageIndex - 1);
  }

  public showNextImage(event) {
    event.preventDefault();

    this.setCurrentImage(this.currentImageIndex + 1);
  }

  public swipe(currentImageIndex: number, swipeType: string) {
    switch (swipeType) {
      case 'swipeleft':
        this.setCurrentImage(currentImageIndex + 1);
        break;
      case 'swiperight':
        this.setCurrentImage(currentImageIndex - 1);
        break;
      default:
        break;
    }
  }
}
